import { render, staticRenderFns } from "./SendDriverStatements.vue?vue&type=template&id=a542fb3e&scoped=true"
import script from "./SendDriverStatements.vue?vue&type=script&lang=js"
export * from "./SendDriverStatements.vue?vue&type=script&lang=js"
import style0 from "./SendDriverStatements.vue?vue&type=style&index=0&id=a542fb3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a542fb3e",
  null
  
)

export default component.exports